<template>
  <el-dialog :visible.sync="dialogVisible" width="296px" :show-close="false">
    <p class="p1">链商平台</p>
    <p class="p2">您确定要进入链商平台，进行交易</p>
    <div class="btn-box">
      <div class="btn1" @click="dialogVisible = false">取消</div>
      <div class="btn2" @click="$emit('confirm')">确认</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__body {
    padding-top: 0px;
  }
}
.p1 {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;
  color: #1f2329;
}
.p2 {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #1f2329;
  margin-top: 20px;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--primary-color);
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }
}
</style>
